import { inject, Injectable } from '@angular/core';
import {
	SwUpdate,
	VersionReadyEvent,
	VersionEvent,
} from '@angular/service-worker';
import { filter } from 'rxjs';
import { NotificationService } from '../services/notification/notification.service';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root',
})
export class PwaUpdateService {
	private readonly swUpdate = inject(SwUpdate);
	private readonly notificationService = inject(NotificationService);
	private initialized = false;

	initialize(): void {
		if (this.initialized) {
			return;
		}

		this.initialized = true;

		if (!environment.pwa.enabled || !this.swUpdate.isEnabled) {
			return;
		}

		this.swUpdate.versionUpdates
			.pipe(
				filter(
					(event: VersionEvent): event is VersionReadyEvent =>
						event.type === 'VERSION_READY'
				)
			)
			.subscribe(() => {
				this.notificationService.open({
					title: 'New App Version',
					subtitle:
						'A new PWA version is ready. Refresh to use the latest version.',
					type: 'info',
					actions: [
						{
							text: 'Refresh now',
							command: () => this.reloadPage(),
						},
					],
				});
			});

		this.swUpdate.unrecoverable.subscribe((event) => {
			this.notificationService.open({
				title: 'App Reload Required',
				subtitle: `An unrecoverable update issue occurred: ${event.reason}`,
				type: 'warn',
				actions: [
					{
						text: 'Reload',
						command: () => this.reloadPage(),
					},
				],
			});
		});
	}

	private reloadPage(): void {
		window.location.reload();
	}
}
